<div class="info-page">
  <h3>{{ actionLabel }} Custos / Financiamento</h3>
</div>

<form [formGroup]="form" (ngSubmit)="salvar()">
  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Custo total estimado (R$)</label>
      <input type="text" id="cost_total" class="form-control text-end" formControlName="cost_total" maxlength="16"
        (keyup)="maskCurrency($event, 'cost_total')" />
      <app-field-message [field]="fieldMessageRequired('cost_total')"
        [erros]="fieldErros('cost_total')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">% Contrapartida</label>
      <input type="text" id="perc_loan" class="form-control text-end" formControlName="perc_loan" maxlength="13"
        (keyup)="maskCurrency($event, 'perc_loan')" />
      <app-field-message [field]="fieldMessageRequired('perc_loan')"
        [erros]="fieldErros('perc_loan')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Valor Concedente/Financiamento (R$)</label>
      <input type="text" id="cost_loan" class="form-control text-end" formControlName="cost_loan" />
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Valor da Contrapartida (R$)</label>
      <input type="text" id="cost_without_loan" class="form-control text-end" formControlName="cost_without_loan" />
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Fonte de recurso da Contrapartida</label>
      <ng-select class="ng-select-alternative" [items]="fonteList" bindLabel="label" bindValue="id"
        formControlName="resource_id">
      </ng-select>
    </div>
  </div>

  <br>
  <div class="info-page">
    <h3>{{ actionLabel }} Estimativa de impacto orçamentário-financeiro</h3>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">O projeto implica em redução de despesas ou aumento de receitas?</label>
      <ng-select class="ng-select-alternative" [items]="reducaoDespesaList" bindLabel="label" bindValue="id"
        formControlName="decreased_spending">
      </ng-select>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">O projeto implica em aumento de despesas de custeio ou renúncia de
        receitas?</label>
      <ng-select class="ng-select-alternative" [items]="aumentoDespesaList" bindLabel="label" bindValue="id"
        formControlName="increased_spending">
      </ng-select>
    </div>
  </div>

  <div class="hr-line-dashed"></div>
  <app-impacto-orcamentario-list *ngIf="projeto" [idProjeto]="projeto.id" [permissoes]="permissoes"
    [permissoes]="permissoes"></app-impacto-orcamentario-list>

  <div *ngIf="projeto?.questions?.length" class="hr-line-dashed"></div>
  <div *ngIf="projeto?.questions?.length">
    <div formArrayName="questions">
      <div *ngFor="let item of projeto?.questions let i = index" [formGroupName]="0">

        <h3 *ngIf="shouldShowHeader(item.tab_group_name, i)" class="mt-4 mb-3">{{item?.tab_group_name}}</h3>

        <div class="form-group row m-b" *ngIf="item?.type_id == filters?.ppQuestion['TYPE_TEXTO']"
          [formGroupName]="item?.question_id">
          <div class="col-xxl-8 col-lg-10 col-sm-12">
            <label class="col-sm-12 pb-1">
              <span *ngIf="!item?.ref_link; else itemLink">{{ item?.title }}</span>
              <ng-template #itemLink>
                <a [href]="item?.ref_link" target="_blank" rel="noopener noreferrer">{{ item?.title }}</a>
              </ng-template>
              <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="item?.tooltip"
                [tooltip]="item?.tooltip"></i>
            </label>
            <textarea class="form-control" formControlName="ds_value" rows="4"
              [maxlength]="item?.max_length"></textarea>
            <app-field-message [field]="fieldMessageRequireds(item?.question_id)"
              [erros]="fieldErrosFormArray(item?.question_id)"></app-field-message>
          </div>
        </div>

        <div class="form-group row m-b" *ngIf="item?.type_id == filters?.ppQuestion['TYPE_NUMERICO']"
          [formGroupName]="item?.question_id">
          <div class="col-xxl-8 col-lg-10 col-sm-12">
            <label class="col-sm-12 pb-1">
              <span *ngIf="!item?.ref_link; else itemLink">{{ item?.title }}</span>
              <ng-template #itemLink>
                <a [href]="item?.ref_link" target="_blank" rel="noopener noreferrer">{{ item?.title }}</a>
              </ng-template>
              <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="item?.tooltip"
                [tooltip]="item?.tooltip"></i>
            </label>
            <input id="filter_cost_total1" class="form-control text-right" formControlName="ds_value"
              (keyup)="formatarMedidaFisica2(item?.question_id, item?.dec_places !== null ? item?.dec_places : 4)">
            <app-field-message [field]="fieldMessageRequireds(item?.question_id)"
              [erros]="fieldErrosFormArray(item?.question_id)"></app-field-message>
          </div>
        </div>

        <div class="form-group row m-b" *ngIf="item?.type_id == filters?.ppQuestion['TYPE_DATA']"
          [formGroupName]="item?.question_id">
          <div class="col-xxl-8 col-lg-10 col-sm-12">
            <label class="col-sm-12 pb-1">
              <span *ngIf="!item?.ref_link; else itemLink">{{ item?.title }}</span>
              <ng-template #itemLink>
                <a [href]="item?.ref_link" target="_blank" rel="noopener noreferrer">{{ item?.title }}</a>
              </ng-template>
              <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="item?.tooltip"
                [tooltip]="item?.tooltip"></i>
            </label>
            <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="ds_value"
              [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa"
              (keyup)="clearInput($event)">
            <app-field-message [field]="fieldMessageRequireds(item?.question_id)"
              [erros]="fieldErrosFormArray(item?.question_id)"></app-field-message>
          </div>
        </div>

        <div class="form-group row m-b" *ngIf="item?.type_id == filters?.ppQuestion['TYPE_COMBO']"
          [formGroupName]="item?.question_id">
          <div class="col-xxl-8 col-lg-10 col-sm-12">
            <label class="col-sm-12 pb-1">
              <span *ngIf="!item?.ref_link; else itemLink">{{ item?.title }}</span>
              <ng-template #itemLink>
                <a [href]="item?.ref_link" target="_blank" rel="noopener noreferrer">{{ item?.title }}</a>
              </ng-template>
              <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="item?.tooltip"
                [tooltip]="item?.tooltip"></i>
            </label>
            <ng-select id="filter_corede_ben" class="ng-select-alternative" [items]="item?.questionList"
              [multiple]="true" bindLabel="ds_value" bindValue="ds_value" placeholder="Todos"
              formControlName="ds_value">
            </ng-select>
            <app-field-message [field]="fieldMessageRequireds(item?.question_id)"
              [erros]="fieldErrosFormArray(item?.question_id)"></app-field-message>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger m-r-xxl" *ngIf="idProjeto && permissoes?.canDelete" (click)="confirmExcluir()" type="button">Excluir</button>
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-white m-r-xs" *ngIf="idProjeto" type="button" (click)="imprimir()">Imprimir</button>
      <button class="btn btn-white m-r-xs" *ngIf="idProjeto && permissoes?.canClone" type="button" (click)="openCloneModal()">Clonar</button>
      <button *ngIf="permissoes?.canSave" class="btn btn-primary" type="submit">Salvar</button>
    </div>
  </div>
</form>
<app-loading [loader]="isLoading"></app-loading>

<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>

<ng-template #modalClone>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Clonar processo</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeCloneModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Novo Nome</label>
        <input class="form-control" [(ngModel)]="clone_title" maxlength="300">
      </div>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closeCloneModal()">Fechar</button>
        <button class="btn btn-primary" type="button" [disabled]="!clone_title" (click)="clonar()">Clonar</button>
      </div>
    </div>
  </div>
</ng-template>